import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BookingDetailPageComponent } from './booking-detail.page';

const routes: Routes = [
  {
    path: '',
    component: BookingDetailPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BookingDetailPageRoutingModule {}
